import React from 'react';
import { withRouter } from 'react-router-dom';
import HeaderContent from './HeaderContent';
import { Button } from 'antd';
const RequestContent = (props) => {
  return (
    <div>
      <HeaderContent
        title='My Requests'
        buttonName='Customize data'
        buttonType='requestList'
        hideCustomizeButtons={props.hideCustomizeButtons}
      />
      <div
        style={{
          paddingTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <a style={{ fontSize: '16px' }} to='#'>
              P1-5
            </a>
            <div style={{ fontSize: '14px', color: '#E01E5A' }}>Open</div>
            <div style={{ fontSize: '16px' }}>Summary Text</div>
            <Button
              className='apphome-display-btn'
              style={{ marginLeft: '140px' }}
            >
              View
            </Button>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              paddingTop: '4px',
            }}
          >
            <a style={{ fontSize: '16px' }} to='#'>
              P1-5
            </a>
            <div style={{ fontSize: '14px', color: '#E01E5A' }}>Open</div>
            <div style={{ fontSize: '16px' }}>Summary Text</div>
            <Button
              className='apphome-display-btn'
              style={{ marginLeft: '140px' }}
            >
              View
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(RequestContent);
